import axios from 'axios'
import {BASE_URL} from '../../services/ApiService/ApiConfig.js';


let token = localStorage.getItem('jwt');
if (token) {
    token = token.replaceAll('"', '');
}

let config = {
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Authorization': 'Bearer ' + token
    }

}

export class ConfiguracionService {

    async getTurno() {
        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/BIT-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    async getListaCandados() {
        return await axios.get(`${BASE_URL}/dispositivo/estado/Activo`,
            config
        ).then(res => res.data.data);
    }

    async getListaSenuelos() {

        return await axios.get(`${BASE_URL}/dispositivo/tipo/192/estado/Activo`,
            config
        ).then(res => res.data.data);
    }

    async getListaCandadosPorTipo() {
        return await axios.get(`${BASE_URL}/dispositivo/tipo/3/estado/Activo`,
            config
        ).then(res => res.data.data);
    }

    async getListaCandadosPorTipo2() {
        return await axios.get(`${BASE_URL}/dispositivo/tipo/3/estado/Activo/2`,
            config
        ).then(res => res.data.data);
    }

    async getListaEmpresas() {
        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/EMP-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    /** Parametros DOLE (DOL-0000-0000): codigo, nombre y parametro de cada uno. */
    async getParametrosDole() {
        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/DOL-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    async getListaTipoViaje() {
        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/VIA-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    async getListaConductores() {

        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }
        let config2 = {
            headers: {
                'Content-Type': "application/json",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios.get(`${BASE_URL}/maestro/persona/tipo-persona/PER-0000-0000-0000`,
            config2
        ).then(res => res.data.data);
    }


}
